import { useApproveCampaign } from 'entities/campaign';
import type { ManagerGetCampaignModel } from 'entities/campaign';
import { Button } from 'shared/ui/Button';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

import {
  hasCampaignValidIntegrations,
  hasCampaignValidSchedule,
  hasCampaignValidSimplyBook,
  isActiveApproveButton,
} from './approve-validation';
import style from './ApproveCampaign.module.scss';

interface ApproveButtonProps {
  campaign: ManagerGetCampaignModel;
}

export function ApproveCampaign({ campaign }: ApproveButtonProps) {
  const approveCampaign = useApproveCampaign(campaign.id);

  return (
    <>
      {!isActiveApproveButton(campaign) ? (
        <div className="text-slate-700">
          Please review this campaign before approving and add the following:
          <ul className={style.approveDetails}>
            {!hasCampaignValidSchedule(campaign.schedule) && <li>Leads receiving time</li>}
            {!hasCampaignValidIntegrations(campaign) && <li>Integration data</li>}
            {!hasCampaignValidSimplyBook(campaign) && <li>Calendar URL</li>}
          </ul>
        </div>
      ) : (
        <>Please review this campaign before approving.</>
      )}
      <Button
        type="button"
        size="medium"
        disabled={!isActiveApproveButton(campaign)}
        loading={approveCampaign.isLoading}
        onClick={() => approveCampaign.mutate()}
        {...getDataAutoTestAttributes(['button-approve-campaign'])}
      >
        Approve campaign
      </Button>
    </>
  );
}
